module.exports = __webpack_public_path__ + "static/media/dodgem(9).10eddc3b.PNG";